import React from "react";

/**
 * Data-driven L99A lego (App / Website Icon and Description).
 *
 * Emits the same `lego l099A` markup as the hand-authored app cards, so it reuses
 * the existing l099A CSS (icon left, description right, 2-up). Returns the cards as
 * siblings (no wrapper) so they flow in the same grid as adjacent l099A cards.
 *
 * Card shape: { title, href, img, description, linkText? }
 *   - linkText: when set, the title renders as a link with this text (website style).
 *     when omitted, renders a plain bold title + a "Click image or this link" line
 *     (app style).
 *
 * Optional `className` on LegoL99AData adds opt-in modifier classes to every card
 * (e.g. "noTitleUnderline"). Omit it and the markup is unchanged.
 */
function L99ACard({ title, href, img, description, linkText, className }) {
  return (
    <div
      className={`lego l099A legoMargin5${linkText ? " websiteCard" : ""}${
        className ? ` ${className}` : ""
      }`}
    >
      <div className="legoContainer">
        <div className="imgContainer">
          <a target="_blank" rel="noreferrer" href={href}>
            <img className="" src={img} alt={title} />
          </a>
        </div>
        <div className="contentContainer">
          {linkText ? (
            <p className="descriptionHeader">
              <a target="_blank" rel="noreferrer" className="blueLinkfont" href={href}>
                {linkText}
              </a>
            </p>
          ) : (
            <p className="descriptionHeader">{title}</p>
          )}
          {description ? <p>{description}</p> : null}
          {linkText ? null : (
            <p style={{ fontStyle: "italic" }}>
              Click image or{" "}
              <a target="_blank" rel="noreferrer" className="blueLinkfont" href={href}>
                this link
              </a>{" "}
              to view.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

function LegoL99AData({ cards = [], className }) {
  return (
    <>
      {cards.map((card, i) => (
        <L99ACard key={card.href || i} {...card} className={className} />
      ))}
    </>
  );
}

export default LegoL99AData;
